import ERC20_ABI from 'abis/erc20.json'
import BigNumber from 'bignumber.js'
import { PAIR_ADDRESS, STAKE_POOL_ADDRESS } from 'constants/addresses'
import { SWC } from 'constants/tokens'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
import multicall from 'utils/multicall'

import { SwcSupplyData } from '../types'

/**
 * Gets all public data of holders contract
 */
const useSwcSupply = (chainId: number): SwcSupplyData => {
  const poolAddress = STAKE_POOL_ADDRESS[chainId]
  const bnbPoolAddress = PAIR_ADDRESS[chainId]
  const swcAddress = SWC[chainId].address
  const { slowRefresh } = useRefresh()

  const [state, setState] = useState({
    totalSupply: BIG_ZERO,
    liquidity: BIG_ZERO,
    staked: BIG_ZERO,
    other: BIG_ZERO,
  })

  const fetchSupplyData = useCallback(async () => {
    const userCalls = [
      {
        address: swcAddress,
        name: 'totalSupply',
      },
      {
        address: swcAddress,
        name: 'balanceOf',
        params: [bnbPoolAddress],
      },
      {
        address: swcAddress,
        name: 'balanceOf',
        params: [poolAddress],
      },
    ]

    const [totalSupply, bnbPool, pool] = await multicall(chainId, ERC20_ABI, userCalls)

    const bigTotalSupply = new BigNumber(totalSupply[0].toString())
    const bigBNB = new BigNumber(bnbPool[0].toString())
    const bigStaked = new BigNumber(pool[0].toString())
    const bigOther = bigTotalSupply.minus(bigBNB.plus(bigStaked))

    setState((prev) => ({
      ...prev,
      totalSupply: bigTotalSupply,
      liquidity: bigBNB,
      staked: bigStaked,
      other: bigOther,
    }))
  }, [bnbPoolAddress, chainId, poolAddress, swcAddress])

  useEffect(() => {
    fetchSupplyData()
  }, [fetchSupplyData, slowRefresh])

  return { ...state, fetchSupplyData }
}

export default useSwcSupply
